import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEMR } from 'src/types/IEMR';

const initialState: IEMR = {
  id: ''
};

export const selectedEMR = createSlice({
  name: 'selectedEMR',
  initialState,
  reducers: {
    clearEMRId: state => {
      state.id = '';
    },
    setSelectedEMRId: (state, action: PayloadAction<any>) => {
      state.id = action.payload;
    }
  }
});

export const { clearEMRId, setSelectedEMRId } = selectedEMR.actions;
